module.exports = __webpack_public_path__ + "img/element-icons-30-x-30-ic-detail-share.0ce04411.svg";